import Resource from 'components/global/Resource'
import { Section, Row, Col } from 'components/grid'
import OverlayVideo from 'components/overlay-video'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { H2 } from 'components/typography/Headings'
import SectionTitle from 'components/global/SectionTitle'

export default function FormativeAssessment({ ...props }) {
	const { language, account, standard } = useContext(CoreAdoptionContext)
	return (
		<Section margin="mt-20" id={formatSectionId(props)} className="scroll-mt-14">
			<Row center>
				<Col>
					<div className="mx-auto mb-10 max-w-3xl text-left sm:text-center">
						<SectionTitle
							title={
								language === 'english'
									? 'Formative Assessment & Targeted Small-Group Instruction'
									: 'Evaluación formativa e instrucción dirigida en grupos pequeños'
							}
							text={[
								<span key={Math.random()}>
									The Independent Reading Level Assessment<sup>®</sup> (IRLA<sup>®</sup>), ARC's standards-based, formative assessment tool, helps teachers
									identify what students know and what skills they need to master next on the path to accelerated reading growth.
								</span>
							]}
						/>

						<OverlayVideo title="Where's the Phonics?" key="phonicsVideo" />

						<p>
							{language === 'english'
								? 'The Guide to IRLA Coaching with Multilingual Learners provides teachers with specific guidance on using the IRLA with multilingual learners.'
								: 'Guide to IRLA Coaching with Multilingual Learners proporciona guía especializada para los/las maestras en el uso de IRLA con lectores/lectoras multilingües.'}
						</p>
					</div>
				</Col>
			</Row>
			<Row className="mx-auto mb-10 max-w-3xl justify-center">
				<Col width="w-full">
					<Row className="items-center">
						{!account?.formative_assessment.includes('IRLA') && (
							<Col width="w-1/2">
								<Resource logResourceView={{ type: 'document' }} protected title="IRLA" />
							</Col>
						)}
						{!account?.formative_assessment.includes('IRLA | TEKS') && standard === 'teks' && (
							<Col width="w-1/2">
								<Resource logResourceView={{ type: 'document' }} protected title="IRLA | TEKS" />
							</Col>
						)}
						{!account?.formative_assessment.includes('MLL Guide') && (
							<Col width="w-1/2">
								<Resource logResourceView={{ type: 'document' }} protected title="MLL Guide" />
							</Col>
						)}
					</Row>
				</Col>
			</Row>
		</Section>
	)
}
